import CustomSelectView from '@/js/desktop/components/customSelect/CustomSelect';

let DepartureCityView = CustomSelectView.extend({
	updateDefaultsValue: function (options = {}) {
		this.viewModel.set({labelTitle: "Город вылета:"});
		this.viewModel.set({defaultLabelValue: "Ищем"});
		this.openCallback = options.openCallback;
	}
});

export default DepartureCityView;
